import { token } from '@atlaskit/tokens';
import { newBackgroundColors, newBorderColors } from '@databases/color-picker/palettes';

export const templateStyles: Record<string, string> = {
  background: token('elevation.surface'),
  border: token('color.border'),
  icon: token('color.icon'),
  boardBackground: token('elevation.surface.sunken'),
  userBackground: token('color.background.neutral'),
  link: token('color.link'),
  fontColor: token('color.text.subtle'),
  fontHeading: token('font.family.heading')
};

export const tagBackgroundColors: Record<string, string> = {
  red: newBackgroundColors['red'],
  blue: newBackgroundColors['blue'],
  green: newBackgroundColors['green'],
  yellow: newBackgroundColors['yellow'],
  orange: newBackgroundColors['orange'],
  teal: newBackgroundColors['teal'],
  lime: newBackgroundColors['lime'],
  magenta: newBackgroundColors['magenta'],
  purple: newBackgroundColors['purple'],
  grey: newBackgroundColors['grey'],

  blueLight: newBackgroundColors['blueLight'],
  redLight: newBackgroundColors['redLight'],
  greenLight: newBackgroundColors['greenLight'],
  greyLight: newBackgroundColors['greyLight'],
  orangeLight: newBackgroundColors['orangeLight'],
  magentaLight: newBackgroundColors['magentaLight'],
  limeLight: newBackgroundColors['limeLight'],
  purpleLight: newBackgroundColors['purpleLight'],
  tealLight: newBackgroundColors['tealLight'],
  yellowLight: newBackgroundColors['yellowLight']
};

export const tagBorderColors: Record<string, string> = {
  red: newBorderColors['red'],
  blue: newBorderColors['blue'],
  green: newBorderColors['green'],
  yellow: newBorderColors['yellow'],
  orange: newBorderColors['orange'],
  teal: newBorderColors['teal'],
  lime: newBorderColors['lime'],
  magenta: newBorderColors['magenta'],
  purple: newBorderColors['purple'],
  grey: newBorderColors['grey'],

  blueLight: newBorderColors['blueLight'],
  redLight: newBorderColors['redLight'],
  greenLight: newBorderColors['greenLight'],
  greyLight: newBorderColors['greyLight'],
  orangeLight: newBorderColors['orangeLight'],
  magentaLight: newBorderColors['magentaLight'],
  limeLight: newBorderColors['limeLight'],
  purpleLight: newBorderColors['purpleLight'],
  tealLight: newBorderColors['tealLight'],
  yellowLight: newBorderColors['yellowLight']
};
